import { SET_DSR_OVERVIEW_PAGE_ID } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_OVERVIEW_PAGE_ID = { id: '' }

export function setOverviewPageIdReducer(state = INITIAL_STATE_SET_OVERVIEW_PAGE_ID, action) {
    switch (action.type) {
        case SET_DSR_OVERVIEW_PAGE_ID:
            return { id: action.payload };
        default:
            return state;
    }
}